'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var LeftNavigationContext = require('./LeftNavigationContext.js');
var LeftNavigationItemWithTab = require('./LeftNavigationItemWithTab.js');
var LeftNavigationItemWithList = require('./LeftNavigationItemWithList.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LeftNavigationItem = function LeftNavigationItem(props) {
  var _useLeftNavigationCon = LeftNavigationContext.useLeftNavigationContext(),
      isUsingList = _useLeftNavigationCon.isUsingList;

  var LeftNavComponent = isUsingList ? LeftNavigationItemWithList : LeftNavigationItemWithTab;
  return React__default["default"].createElement(LeftNavComponent, _objectSpread({}, props));
};

module.exports = LeftNavigationItem;
